import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TipusIncidencia } from './TipusIncidencia';
import { convertirSegonsaHores, convertirSegonsAMinuts, numeroSegonsEntreDates } from '../../Helpers/funcionsDates';
import moment from 'moment';

// Llegeix directament de cp.detallSetmana (ja carregat per HoresTotalsSetmana)
// 0 crides HTTP addicionals

export const LlistatIncidenciesDia = ({ dataAvui }) => {
  const [t] = useTranslation('generic');
  const { cp } = useSelector(state => ({ cp: state.cp }));

  const diaStr = moment(dataAvui).format('YYYY-MM-DD');

  const { listItems, horesVali, minutsVali, horesNoVali, minutsNoVali } = useMemo(() => {
    const incidencies = cp?.detallSetmana?.llistatIncidencies?.filter(e => {
      const inici = moment(e.DataInici_IncidenciaFix).format('YYYY-MM-DD');
      const fi    = moment(e.DataFi_IncidenciaFix).format('YYYY-MM-DD');
      return diaStr >= inici && diaStr <= fi;
    }) ?? [];

    if (!incidencies.length) {
      return { listItems: null, horesVali: 0, minutsVali: 0, horesNoVali: 0, minutsNoVali: 0 };
    }

    let segonsJustificats = 0;
    let segonsNoJustificats = 0;

    const items = incidencies.map(d => {
      const durada = numeroSegonsEntreDates(d.DataInici_IncidenciaFix, d.DataFi_IncidenciaFix);
      if (d.Justificat_IncidenciaFix === '1') segonsJustificats += durada;
      else segonsNoJustificats += durada;

      return (
        <li key={d.IdIncidenciaFix}>
          <TipusIncidencia IdTipusIncidencia_IncidenciaFix={Number(d.IdTipusIncidencia_IncidenciaFix)} /> -{' '}
          <Moment format="HH:mm" date={d.DataInici_IncidenciaFix} />{' '}
          <Moment format="HH:mm" date={d.DataFi_IncidenciaFix} />
          {d.ValidatResponsable_IncidenciaFix === '1' && d.Justificat_IncidenciaFix === '1' ? (
            <p>Validat i justificat</p>
          ) : d.ValidatResponsable_IncidenciaFix === '1' && d.Justificat_IncidenciaFix !== '0' ? (
            <p>Validat per responsable</p>
          ) : (
            <p>Pendent de validació</p>
          )}
        </li>
      );
    });

    return {
      listItems: items,
      horesVali:   convertirSegonsaHores(segonsJustificats),
      minutsVali:  convertirSegonsAMinuts(segonsJustificats),
      horesNoVali:  convertirSegonsaHores(segonsNoJustificats),
      minutsNoVali: convertirSegonsAMinuts(segonsNoJustificats),
    };
  }, [cp?.detallSetmana, diaStr]);

  return (
    <>
      <ul>
        {listItems}
        <p>Un total de {horesVali} hores i {minutsVali} minuts validats</p>
        <p>Un total de {horesNoVali} hores i {minutsNoVali} minuts No validats</p>
      </ul>
    </>
  );
};

LlistatIncidenciesDia.propTypes = {
  dataAvui: PropTypes.instanceOf(Date)
};